Vue.component('ack-main-title', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-main-title',
	mounted() {
		appLog.log('ack-main-title mounted');
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	computed: {
		//...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
		...Vuex.mapGetters(['isMobile']),
		rowMb() {
			return this.data.companyLogos ? (!this.isMobile ? 'mb-3' : 'mb-4') : '';
		},
	},
	data() {
		return {
			pageId: 'main-title',
		};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),
	},
	beforeDestroy() {},
	watch: {
		data: {
			handler() {},
			deep: false,
		},
	},
});
